import { Box } from '@base-app';
import { styled } from '@/stitches.config';
import { ReactComponent as ArrowIcon } from '@assets/icons/arrow-left.svg';
import { CSS } from '@stitches/react';
import { ReactComponent as SpinnerIcon } from '@assets/icons/spinner.svg';

export const StyledContainer = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledSchedulerContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '$4',
  width: '100%',
  '@md': {
    flexDirection: 'row',
  },
});

export const StyledCalendarContainer = styled(Box, {
  alignSelf: 'flex-start',
  display: 'flex',
  position: 'relative',
  width: '100%',
  '@md': {
    alignContent: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    width: '45%',
  },
});

export const StyledSpinnerIcon = styled(SpinnerIcon, {
  height: '$12',
  stroke: '$primary',
  marginTop: '$4',
  width: '$12',
});

export const StyledCalendarLoaderContainer = styled(Box, {
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  display: 'flex',
  height: '460px',
  justifyContent: 'center',
  position: 'absolute',
  width: '100%',
  zIndex: '$zIndices$loader',
});

export const StyledTimeRangesContainer = styled(Box, {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: '$10',
  width: '100%',
  '@md': {
    marginLeft: '$20',
    marginRight: '$20',
    marginTop: '0',
    width: '55%',
  },
});

export const StyledArrowIcon = styled(ArrowIcon, {
  color: '$blue300',
  height: '$6',
  marginRight: '$1',
  width: '$6',
});

export const StyledBackButtonText = styled('span', {
  fontSize: '$sm',
  fontWeight: '$medium',
});

export const StyledTimeRangeTitle = styled('span', {
  color: '$darkBlue300',
  fontSize: '$lg',
  fontWeight: '$bold',
  lineHeight: '$6',
  marginBottom: '$6',
  marginLeft: '$2',
  textAlign: 'left',
});

export const StyledProcessLoaderContainer = styled(Box, {
  margin: 'auto',
  maxWidth: '200px',
});

export const bookApptBtnStyles: CSS = {
  marginLeft: '$2',
  minWidth: '194px',
};
